import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";

const EmptyRecommendations = ({ text }: { text: string }) => (
  <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-py-12">
    <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1771314135/intel/misc/Empty_state_AI_illustration_1_wgbemg.webp`} alt="No Prospects Found" className="tw-w-56" />
    <span className="tw-text-base tw-font-semibold tw-text-gray-900">No Suggestions Yet</span>
    <span className="tw-max-w-md tw-text-center tw-text-sm tw-text-gray-500">{text}</span>
  </div>
);

export default EmptyRecommendations;
